var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmingPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4321 0.443359H16.5677C7.66256 0.443359 0.443481 7.66244 0.443481 16.5676V47.432C0.443481 56.3372 7.66256 63.5563 16.5677 63.5563H47.4321C56.3373 63.5563 63.5564 56.3372 63.5564 47.432V16.5676C63.5564 7.66244 56.3373 0.443359 47.4321 0.443359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1355 21.9639H36.561",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1355 26.1357H36.561",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1355 30.3047H36.561",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1355 18.8359V33.0915",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 18.8359V33.3391",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8334 36.5596C21.961 36.5596 21.961 38.6448 25.0887 38.6448C28.2163 38.6448 28.2163 36.5596 31.344 36.5596C34.4716 36.5596 34.4716 38.6448 37.5994 38.6448C40.727 38.6448 40.727 36.5596 43.8547 36.5596",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8334 41.7734C21.961 41.7734 21.961 43.8585 25.0887 43.8585C28.2163 43.8585 28.2163 41.7734 31.344 41.7734C34.4716 41.7734 34.4716 43.8585 37.5994 43.8585C40.727 43.8585 40.727 41.7734 43.8547 41.7734",
    stroke: "#311806",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingPool);
export default __webpack_public_path__ + "static/media/swimming-pool.e702581c9b364dfb195aee8e8875adf4.svg";
export { ForwardRef as ReactComponent };